import request from '@/utils/request'

let CompanyApi = {

  /*公司列表*/
  list(data) {
    return request._post('/shop/plus.company.Index/index', data);
},
/*添加公司*/
add(data) {
    return request._post('/shop/plus.company.Index/add', data);
},
/*修改公司*/
edit(data) {
    return request._post('/shop/plus.company.Index/edit', data);
},
/*删除公司*/
del(data) {
    return request._post('/shop/plus.company.Index/del', data);
},
/*公司详情*/
detail(data) {
  return request._post('/shop/plus.company.Index/detail', data);
},
 // 审核
 passCanel(data) {
  return request._post('/shop/plus.company.Index/passCanel', data);
},
getCategory(data) {
  return request._post('/shop/plus.company.Index/getCategory', data);
},
/*统计*/
statisticList(data) {
    return request._post('/shop/plus.company.Index/statisticList', data);
},
}
export default CompanyApi;



// WEBPACK FOOTER //
// ./src/api/company.js